<template>
  <BaseListItem>
    <template #title>
      <span>
        [{{ mandalaGoalTemplate.displayOrder | padStartZero }}] {{ mandalaGoalTemplate.name }} 
      </span>
    </template>
    <template #actions>
      <IconButton
        icon="edit"
        color="grey"
        icon-color="black"
        @click="() => $router.push(`/admin/mandala_goal_templates/${mandalaGoalTemplate.id}`)" />
    </template>
    <template #badges>
      <BaseBadge
        width="50"
        :color="status === 'published' ? 'primary' : 'dark'">
        {{ statusText[status] }}
      </BaseBadge>
    </template>
  </BaseListItem>
</template>

<script>
import IconButton from '@/components/parts/IconButton.vue'
import BaseBadge from '@/components/parts/BaseBadge.vue'
export default {
  components: {
    IconButton,
    BaseBadge
  },
  props: {
    mandalaGoalTemplate: {
      type: Object,
      required: true
    },
  },
  computed: {
    status() {
      return this.mandalaGoalTemplate.status
    },
    statusText() {
      return {
        published: '公開',
        draft: '下書き',
        private: '非公開'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>